/**
 * requireRoot — TanStack Router beforeLoad helper that gates a route to
 * users with system_role='root'.
 *
 * Synchronous redirect via `throw redirect(...)` runs BEFORE the component
 * mounts, so any top-level useQuery in the gated component never fires for
 * non-root admins (avoids the brief data fetch + render flash that an
 * in-component guard would let through).
 *
 * Reads from useAuthStore directly — caller is responsible for ensuring auth
 * has already hydrated (typically by chaining `await requireAuth(...)` first
 * in the parent route's beforeLoad).
 */

import { redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/useAuthStore";

export function requireRoot(): void {
  const user = useAuthStore.getState().user;
  if (user?.systemRole !== "root") {
    // Redirect to the system-admin landing rather than home — the user IS a
    // system admin (parent guard passed), just not root. Sending them home
    // would be more disorienting than parking on the dashboard.
    throw redirect({ to: "/system-admin", replace: true });
  }
}
